/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Admin_Resources_Images_Input_CountInputs */

const en_admin_resources_images_input_count = /** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const de_admin_resources_images_input_count = /** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const es_admin_resources_images_input_count = /** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const fr_admin_resources_images_input_count = /** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

const nl_admin_resources_images_input_count = /** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.max}`)
};

/** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */
const it_admin_resources_images_input_count = en_admin_resources_images_input_count;

/** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */
const pt_br2_admin_resources_images_input_count = en_admin_resources_images_input_count;

/** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */
const pl_admin_resources_images_input_count = en_admin_resources_images_input_count;

/** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */
const hu_admin_resources_images_input_count = en_admin_resources_images_input_count;

/** @type {(inputs: Admin_Resources_Images_Input_CountInputs) => LocalizedString} */
const ro_admin_resources_images_input_count = en_admin_resources_images_input_count;

/**
* | output |
* | --- |
* | "{count}/{max}" |
*
* @param {Admin_Resources_Images_Input_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_images_input_count = /** @type {((inputs: Admin_Resources_Images_Input_CountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Images_Input_CountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_images_input_count(inputs)
	if (locale === "de") return de_admin_resources_images_input_count(inputs)
	if (locale === "es") return es_admin_resources_images_input_count(inputs)
	if (locale === "fr") return fr_admin_resources_images_input_count(inputs)
	if (locale === "nl") return nl_admin_resources_images_input_count(inputs)
	if (locale === "it") return it_admin_resources_images_input_count(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_images_input_count(inputs)
	if (locale === "pl") return pl_admin_resources_images_input_count(inputs)
	if (locale === "hu") return hu_admin_resources_images_input_count(inputs)
	return ro_admin_resources_images_input_count(inputs)
});
export { admin_resources_images_input_count as "admin.resources.images_input.count" }